import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AccountState } from '@account-users/account/models/IAccount';

@Component({
  selector: 'app-account-status-item',
  templateUrl: './account-status-item.component.html',
  styleUrls: ['./account-status-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountStatusItemComponent {
  @Input() header = '';
  @Input() status: AccountState;
  @Input() errorMessage = '';

  AccountState = AccountState;
}
